require([]);
define("commons/empty-main", function(){});

